import React, { useState } from "react";
import {
	Box,
	Typography,
	IconButton,
	TextField,
	Button,
	Checkbox,
	LinearProgress,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import LuggageIcon from "@mui/icons-material/Luggage";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { BasicModal } from "../BasicModal/BasicModal";
import { useWindowSize } from "@uidotdev/usehooks";
import {
	TRAVEL_KIT_MODAL,
	textFieldSx,
	modalContentSx,
	primaryButtonSx,
	secondaryButtonSx,
} from "./TravelKitModalStyles";

// Template103: Travel Kit - Checklist de Maleta
const Template103 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
	registerScrollContainer,
	isViewer = false,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const setScrollContainerRef = (domNode) => {
		if (typeof registerScrollContainer === "function") {
			registerScrollContainer(domNode);
		}
	};

	const pageData = page.data || {};
	const [categories, setCategories] = useState(() => {
		if (pageData.categories?.length > 0) {
			return pageData.categories;
		}
		// Paleta pastel scrapbook (sin azules)
		
		return [
			{
				id: 1,
				name: "Ropa",
				emoji: "👕",
				color: "#E8B4BC",
				items: [
					{ id: 1, text: "Camisetas / tops", checked: false, quantity: "" },
					{ id: 2, text: "Pantalones / faldas", checked: false, quantity: "" },
					{ id: 3, text: "Ropa interior", checked: false, quantity: "" },
					{ id: 4, text: "Calcetines", checked: false, quantity: "" },
					{ id: 5, text: "Pijama", checked: false, quantity: "" },
					{ id: 6, text: "Chaqueta / abrigo", checked: false, quantity: "" },
					{ id: 7, text: "Calzado cómodo", checked: false, quantity: "" },
				],
			},
			{
				id: 2,
				name: "Aseo",
				emoji: "🧴",
				color: "#C5E8D4",
				items: [
					{
						id: 1,
						text: "Cepillo y pasta de dientes",
						checked: false,
						quantity: "",
					},
					{ id: 2, text: "Champú / gel", checked: false, quantity: "" },
					{ id: 3, text: "Desodorante", checked: false, quantity: "" },
					{ id: 4, text: "Crema hidratante", checked: false, quantity: "" },
					{ id: 5, text: "Protector solar", checked: false, quantity: "" },
					{ id: 6, text: "Medicamentos", checked: false, quantity: "" },
				],
			},
			{
				id: 3,
				name: "Electrónica",
				emoji: "📱",
				color: "#D4B8E8",
				items: [
					{ id: 1, text: "Cargador móvil", checked: false, quantity: "" },
					{ id: 2, text: "Power bank", checked: false, quantity: "" },
					{ id: 3, text: "Adaptador de enchufe", checked: false, quantity: "" },
					{ id: 4, text: "Auriculares", checked: false, quantity: "" },
					{ id: 5, text: "Cámara de fotos", checked: false, quantity: "" },
				],
			},
			{
				id: 4,
				name: "Documentos",
				emoji: "📄",
				color: "#F5E6C8",
				items: [
					{ id: 1, text: "Pasaporte / DNI", checked: false, quantity: "" },
					{ id: 2, text: "Tarjetas de embarque", checked: false, quantity: "" },
					{ id: 3, text: "Reservas impresas", checked: false, quantity: "" },
					{ id: 4, text: "Seguro de viaje", checked: false, quantity: "" },
					{ id: 5, text: "Carnet de conducir", checked: false, quantity: "" },
				],
			},
			{
				id: 5,
				name: "Extras",
				emoji: "🎒",
				color: "#A8D5BA",
				items: [
					{ id: 1, text: "Gafas de sol", checked: false, quantity: "" },
					{ id: 2, text: "Libro / kindle", checked: false, quantity: "" },
					{ id: 3, text: "Snacks", checked: false, quantity: "" },
					{ id: 4, text: "Botella de agua", checked: false, quantity: "" },
				],
			},
		];
	});

	const [editModal, setEditModal] = useState(false);
	const [editingCategory, setEditingCategory] = useState(null);
	const [tempCategory, setTempCategory] = useState({
		name: "",
		emoji: "",
		color: "",
	});
	const [editItemModal, setEditItemModal] = useState(false);
	const [editingItemCategoryIndex, setEditingItemCategoryIndex] =
		useState(null);
	const [editingItemIndex, setEditingItemIndex] = useState(null);
	const [tempItemText, setTempItemText] = useState("");

	const updatePageData = (newCategories) => {
		updatePage({
			...page,
			data: { ...pageData, categories: newCategories },
		});
	};

	const handleToggleItem = (categoryIndex, itemIndex) => {
		const newCategories = [...categories];
		newCategories[categoryIndex].items[itemIndex].checked =
			!newCategories[categoryIndex].items[itemIndex].checked;
		setCategories(newCategories);
		updatePageData(newCategories);
	};

	const handleAddItem = (categoryIndex) => {
		const newCategories = [...categories];
		const newId =
			Math.max(0, ...newCategories[categoryIndex].items.map((i) => i.id)) + 1;
		newCategories[categoryIndex].items.push({
			id: newId,
			text: "Nuevo item",
			checked: false,
			quantity: "",
		});
		setCategories(newCategories);
		updatePageData(newCategories);
	};

	const handleDeleteItem = (categoryIndex, itemIndex) => {
		const newCategories = [...categories];
		newCategories[categoryIndex].items.splice(itemIndex, 1);
		setCategories(newCategories);
		updatePageData(newCategories);
	};

	const handleEditItem = (categoryIndex, itemIndex, newText) => {
		const newCategories = [...categories];
		newCategories[categoryIndex].items[itemIndex].text = newText;
		setCategories(newCategories);
		updatePageData(newCategories);
	};

	const handleOpenEditItem = (categoryIndex, itemIndex) => {
		setEditingItemCategoryIndex(categoryIndex);
		setEditingItemIndex(itemIndex);
		setTempItemText(categories[categoryIndex].items[itemIndex].text);
		setEditItemModal(true);
	};

	const handleSaveEditItem = () => {
		if (editingItemCategoryIndex === null || editingItemIndex === null) return;
		handleEditItem(editingItemCategoryIndex, editingItemIndex, tempItemText);
		setEditItemModal(false);
	};

	const handleEditCategory = (categoryIndex) => {
		setEditingCategory(categoryIndex);
		setTempCategory({
			name: categories[categoryIndex].name,
			emoji: categories[categoryIndex].emoji,
			color: categories[categoryIndex].color,
		});
		setEditModal(true);
	};

	const handleSaveCategory = () => {
		const newCategories = [...categories];
		newCategories[editingCategory] = {
			...newCategories[editingCategory],
			...tempCategory,
		};
		setCategories(newCategories);
		updatePageData(newCategories);
		setEditModal(false);
	};

	const handleAddCategory = () => {
		const colors = [
			"#E8B4BC",
			"#C5E8D4",
			"#D4B8E8",
			"#F5E6C8",
			"#A8D5BA",
			"#F5C6D8",
		];
		const newId = Math.max(0, ...categories.map((c) => c.id)) + 1;
		const newCategories = [
			...categories,
			{
				id: newId,
				name: "Nueva categoría",
				emoji: "📦",
				color: colors[newId % colors.length],
				items: [{ id: 1, text: "Nuevo item", checked: false, quantity: "" }],
			},
		];
		setCategories(newCategories);
		updatePageData(newCategories);
	};

	const handleDeleteCategory = (categoryIndex) => {
		const newCategories = categories.filter((_, i) => i !== categoryIndex);
		setCategories(newCategories);
		updatePageData(newCategories);
	};

	const handleResetAll = () => {
		const newCategories = categories.map((cat) => ({
			...cat,
			items: cat.items.map((item) => ({ ...item, checked: false })),
		}));
		setCategories(newCategories);
		updatePageData(newCategories);
	};

	// Calcular progreso
	const totalItems = categories.reduce((acc, cat) => acc + cat.items.length, 0);
	const checkedItems = categories.reduce(
		(acc, cat) => acc + cat.items.filter((i) => i.checked).length,
		0
	);
	const progress =
		totalItems > 0 ? Math.round((checkedItems / totalItems) * 100) : 0;

	// Paleta pastel scrapbook (sin azules)
	const colorOptions = [
		"#E8B4BC",
		"#C5E8D4",
		"#D4B8E8",
		"#F5E6C8",
		"#A8D5BA",
		"#F5C6D8",
		"#E8D4E4",
		"#D4E8E4",
		"#F0D8A8",
		"#E8C8D8",
	];

	const templateItemProps = {
		"data-template-item": true,
		className: "template-item",
	};

	return (
		<Box
			{...templateItemProps}
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				width: "100%",
				backgroundColor: backgroundColor || "#FFF6F0",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				position: "relative",
				zIndex: 1,
				pointerEvents: "none",
				"& [data-template-item]": { pointerEvents: "auto" },
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
				backgroundImage: `
					radial-gradient(ellipse at 20% 50%, rgba(201,164,232,0.08) 0%, transparent 50%),
					radial-gradient(ellipse at 80% 20%, rgba(244,166,188,0.08) 0%, transparent 50%),
					radial-gradient(ellipse at 50% 80%, rgba(142,207,171,0.08) 0%, transparent 50%)
				`,
			}}
		>
			{/* Header: mismo estilo que Template104 - washi strip + sticker */}
			<Box
				data-block-id="header"
				sx={{
					position: "sticky",
					top: 0,
					zIndex: 1054,
					padding: isSmallScreen ? "12px 16px" : "16px 20px",
					backgroundColor: "rgb(248, 250, 252)",
					backgroundImage: `repeating-linear-gradient(
						95deg,
						transparent,
						transparent 6px,
						rgba(245, 230, 200, 0.5) 6px,
						rgba(245, 230, 200, 0.5) 9px
					)`,
					borderBottom: "3px dashed rgba(92, 58, 69, 0.2)",
					boxShadow: "0 4px 12px rgba(245, 230, 200, 0.4)",
				}}
			>
				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						justifyContent: "space-between",
						marginBottom: 1.5,
						flexWrap: "wrap",
						gap: 1,
					}}
				>
					<Box
						sx={{
							display: "inline-flex",
							alignItems: "center",
							gap: 1.5,
							backgroundColor: "rgba(255,255,255,0.95)",
							borderRadius: "24px",
							padding: "10px 18px",
							boxShadow:
								"0 3px 14px rgba(232, 180, 188, 0.3), 0 1px 3px rgba(0,0,0,0.06)",
							border: "2px solid rgba(245, 230, 200, 0.9)",
							transform: "rotate(-1.2deg)",
						}}
					>
						<LuggageIcon sx={{ fontSize: 22, color: "#5C9B6E" }} />
						<Typography
							sx={{
								fontSize: "17px !important",
								fontWeight: "800 !important",
								color: "#5C3A45",
							}}
						>
							✿ Mi Maleta ✿
						</Typography>
					</Box>
					<IconButton
						{...templateItemProps}
						className={[templateItemProps?.className, "hide-in-viewer"].filter(Boolean).join(" ")}
						onClick={() => !isViewer && handleResetAll()}
						size="small"
						sx={{
							backgroundColor: "rgba(255,255,255,0.9)",
							border: "2px dashed rgba(92, 58, 69, 0.2)",
							color: "#5C3A45",
							"&:hover": { backgroundColor: "#FFE4EC" },
						}}
						title="Resetear todo"
					>
						<RestartAltIcon sx={{ fontSize: 20 }} />
					</IconButton>
				</Box>

				{/* Progress en sticker */}
				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						gap: 2,
						backgroundColor: "rgba(255,255,255,0.9)",
						borderRadius: "16px",
						padding: "10px 14px",
						border: "2px dashed rgba(197, 232, 212, 0.6)",
						boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
						transform: "rotate(0.8deg)",
					}}
				>
					<Box sx={{ flex: 1 }}>
						<LinearProgress
							variant="determinate"
							value={progress}
							sx={{
								height: 10,
								borderRadius: 5,
								backgroundColor: "rgba(197, 232, 212, 0.5)",
								"& .MuiLinearProgress-bar": {
									backgroundColor: "#5C9B6E",
									borderRadius: 5,
								},
							}}
						/>
					</Box>
					<Typography
						sx={{
							fontSize: "13px !important",
							fontWeight: "700 !important",
							color: "#2D5A3D",
							minWidth: "42px",
						}}
					>
						{progress}%
					</Typography>
				</Box>
				<Typography
					sx={{
						fontSize: "11px !important",
						color: "#2D5A3D",
						opacity: 0.9,
						marginTop: 0.5,
					}}
				>
					{checkedItems} de {totalItems} items empacados
				</Typography>
			</Box>

			{/* Content */}
			<Box
				ref={setScrollContainerRef}
				data-template103-scroll
				sx={{
					flex: 1,
					minHeight: 0,
					overflow: "auto",
					WebkitOverflowScrolling: "touch",
					padding: isSmallScreen ? "12px" : "16px",
				}}
			>
				<Box
					sx={{
						display: "grid",
						gridTemplateColumns: isSmallScreen ? "1fr" : "repeat(2, 1fr)",
						gap: 2.5,
					}}
				>
					{categories.map((category, categoryIndex) => (
						<Box
							key={category.id}
							data-block-id={`text-${categoryIndex + 1}`}
							{...templateItemProps}
							sx={{
								transform:
									categoryIndex % 2 === 0 ? "rotate(-1deg)" : "rotate(1.2deg)",
								transition: "transform 0.2s ease",
							}}
						>
							{/* Cinta washi arriba */}
							<Box
								sx={{
									height: 8,
									backgroundColor: category.color,
									opacity: 0.9,
									borderRadius: "6px 6px 0 0",
									marginLeft: 1.5,
									marginRight: 1.5,
									border: "1px dashed rgba(255,255,255,0.5)",
								}}
							/>
							<Box
								sx={{
									backgroundColor: "#fff",
									borderRadius: "0 0 20px 20px",
									overflow: "hidden",
									boxShadow:
										"0 6px 24px rgba(232, 180, 188, 0.18), 0 2px 6px rgba(0,0,0,0.06)",
									border: "2px solid rgba(232, 180, 188, 0.25)",
									borderTop: "none",
								}}
							>
								{/* Category Header */}
								<Box
									sx={{
										backgroundColor: category.color,
										padding: "10px 14px",
										display: "flex",
										alignItems: "center",
										justifyContent: "space-between",
										borderBottom: "2px dashed rgba(255,255,255,0.5)",
									}}
								>
									<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
										<Typography sx={{ fontSize: "18px" }}>
											{category.emoji}
										</Typography>
										<Typography
											sx={{
												color: "#fff",
												fontWeight: "600 !important",
												fontSize: "13px !important",
											}}
										>
											{category.name}
										</Typography>
										<Typography
											sx={{
												color: "rgba(255,255,255,0.7)",
												fontSize: "11px !important",
											}}
										>
											({category.items.filter((i) => i.checked).length}/
											{category.items.length})
										</Typography>
									</Box>
									<Box className="hide-in-viewer" sx={{ display: "flex" }}>
										<IconButton
											{...templateItemProps}
											onClick={() => !isViewer && handleEditCategory(categoryIndex)}
											size="small"
											sx={{ color: "rgba(255,255,255,0.8)", padding: "4px" }}
										>
											<EditIcon sx={{ fontSize: 14, pointerEvents: "none" }} />
										</IconButton>
										<IconButton
											{...templateItemProps}
											onClick={() => !isViewer && handleDeleteCategory(categoryIndex)}
											size="small"
											sx={{ color: "rgba(255,255,255,0.8)", padding: "4px" }}
										>
											<DeleteIcon sx={{ fontSize: 14, pointerEvents: "none", pointerEvents: "none" }} />
										</IconButton>
									</Box>
								</Box>

								{/* Items */}
								<Box sx={{ padding: "8px 12px" }}>
									{category.items.map((item, itemIndex) => (
										<Box
											key={item.id}
											sx={{
												display: "flex",
												alignItems: "center",
												padding: "6px 0",
												borderBottom:
													itemIndex < category.items.length - 1
														? "1px solid #f1f5f9"
														: "none",
											}}
										>
											<Checkbox
												{...templateItemProps}
												checked={item.checked}
												onChange={() =>
													handleToggleItem(categoryIndex, itemIndex)
												}
												icon={
													<RadioButtonUncheckedIcon
														sx={{ color: "#ddd", fontSize: 20 }}
													/>
												}
												checkedIcon={
													<CheckCircleIcon
														sx={{ color: category.color, fontSize: 20 }}
													/>
												}
												sx={{ padding: "4px" }}
											/>
											<Box
												{...templateItemProps}
												onClick={() =>
													!isViewer && handleOpenEditItem(categoryIndex, itemIndex)
												}
												sx={{
													flex: 1,
													cursor: isViewer ? "default" : "pointer",
												}}
											>
												<Typography
													sx={{
														fontSize: "13px !important",
														color: item.checked ? "#94A3B8" : "#334155",
														textDecoration: item.checked
															? "line-through"
															: "none",
													}}
												>
													{item.text}
												</Typography>
											</Box>
											<IconButton
												{...templateItemProps}
												className={[templateItemProps?.className, "hide-in-viewer"].filter(Boolean).join(" ")}
												onClick={() =>
													!isViewer && handleDeleteItem(categoryIndex, itemIndex)
												}
												size="small"
												sx={{ opacity: 0.4, "&:hover": { opacity: 1 } }}
											>
												<DeleteIcon sx={{ fontSize: 14, pointerEvents: "none" }} />
											</IconButton>
										</Box>
									))}

									<Button
										{...templateItemProps}
										className={[templateItemProps?.className, "hide-in-viewer"].filter(Boolean).join(" ")}
										onClick={() => !isViewer && handleAddItem(categoryIndex)}
										startIcon={<AddIcon sx={{ fontSize: 14, pointerEvents: "none" }} />}
										sx={{
											textTransform: "none",
											fontSize: "11px",
											color: category.color,
											padding: "4px 8px",
											marginTop: "4px",
											border: "1px solid #d4d4d4 !important",
                                            color: "#c7c7c7 !important",
    										fontSize: "14px !important",
    										borderRadius: "12px !important",
    										padding: "6px 12px !important",
										}}
									>
										Añadir
									</Button>
								</Box>
							</Box>
						</Box>
					))}

					{/* Add Category - recorte scrapbook */}
					<Box
						{...templateItemProps}
						className={[templateItemProps?.className, "hide-in-viewer"].filter(Boolean).join(" ")}
						onClick={() => !isViewer && handleAddCategory()}
						sx={{
							backgroundColor: "#fff",
							borderRadius: "20px",
							border: "2px dashed #E8B4BC",
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							justifyContent: "center",
							padding: "30px",
							cursor: "pointer",
							transition: "all 0.2s",
							boxShadow: "0 4px 20px rgba(232, 180, 188, 0.15)",
							transform: "rotate(0.5deg)",
							"&:hover": {
								borderColor: "#E8B4BC",
								backgroundColor: "#FFE4EC",
								transform: "rotate(0.5deg) scale(1.02)",
							},
						}}
					>
						<AddIcon sx={{ fontSize: 28, color: "#B8959E", marginBottom: 1, pointerEvents: "none" }} />
						<Typography
							sx={{
								color: "#5C3A45",
								fontSize: "12px !important",
								fontWeight: 600,
								pointerEvents: "none",
							}}
						>
							✿ Nueva categoría
						</Typography>
					</Box>
				</Box>
			</Box>

			{/* Edit Item Modal - oculto en viewer */}
			<Box className="hide-in-viewer">
			<BasicModal
				width={400}
				showModal={editItemModal}
				handleClose={() => setEditItemModal(false)}
				contentSx={modalContentSx}
			>
				<Box sx={{ p: 3 }}>
					<Typography
						sx={{
							fontSize: "18px !important",
							fontWeight: 700,
							color: TRAVEL_KIT_MODAL.textPrimary,
							mb: 2,
							fontFamily: "'Inter', sans-serif",
						}}
					>
						Editar item
					</Typography>
					<TextField
						label="Texto del item"
						value={tempItemText}
						onChange={(e) => setTempItemText(e.target.value)}
						fullWidth
						size="small"
						margin="normal"
						placeholder="Ej: Camisetas / tops"
						autoFocus
						sx={textFieldSx}
					/>
					<Box
						sx={{
							display: "flex",
							justifyContent: "flex-end",
							gap: 1.5,
							mt: 3,
						}}
					>
						<Button
							onClick={() => setEditItemModal(false)}
							sx={secondaryButtonSx}
						>
							Cancelar
						</Button>
						<Button
							variant="contained"
							onClick={handleSaveEditItem}
							sx={primaryButtonSx}
						>
							Guardar
						</Button>
					</Box>
				</Box>
			</BasicModal>
			</Box>

			{/* Edit Category Modal - diseño coherente con dashboard */}
			<Box className="hide-in-viewer">
			<BasicModal
				width={400}
				showModal={editModal}
				handleClose={() => setEditModal(false)}
				contentSx={modalContentSx}
			>
				<Box sx={{ p: 3 }}>
					<Typography
						sx={{
							fontSize: "18px !important",
							fontWeight: 700,
							color: TRAVEL_KIT_MODAL.textPrimary,
							mb: 2,
							fontFamily: "'Inter', sans-serif",
						}}
					>
						Editar categoría
					</Typography>

					<TextField
						label="Nombre"
						value={tempCategory.name}
						onChange={(e) =>
							setTempCategory({ ...tempCategory, name: e.target.value })
						}
						fullWidth
						size="small"
						margin="normal"
						placeholder="Ej: Ropa"
						sx={textFieldSx}
					/>
					<TextField
						label="Emoji"
						value={tempCategory.emoji}
						onChange={(e) =>
							setTempCategory({ ...tempCategory, emoji: e.target.value })
						}
						fullWidth
						size="small"
						margin="normal"
						placeholder="👕"
						sx={textFieldSx}
					/>

					<Typography
						sx={{
							fontSize: "13px !important",
							fontWeight: 600,
							color: TRAVEL_KIT_MODAL.textMuted,
							mt: 2,
							mb: 1.5,
							fontFamily: "'Inter', sans-serif",
						}}
					>
						Color
					</Typography>
					<Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
						{colorOptions.map((color) => (
							<Box
								key={color}
								onClick={() => setTempCategory({ ...tempCategory, color })}
								sx={{
									width: 32,
									height: 32,
									borderRadius: "50%",
									backgroundColor: color,
									cursor: "pointer",
									border:
										tempCategory.color === color
											? `3px solid ${TRAVEL_KIT_MODAL.textPrimary}`
											: "3px solid transparent",
									transition: "transform 0.1s",
									"&:hover": { transform: "scale(1.1)" },
								}}
							/>
						))}
					</Box>

					<Box
						sx={{
							display: "flex",
							justifyContent: "flex-end",
							gap: 1.5,
							mt: 3,
						}}
					>
						<Button onClick={() => setEditModal(false)} sx={secondaryButtonSx}>
							Cancelar
						</Button>
						<Button
							variant="contained"
							onClick={handleSaveCategory}
							sx={primaryButtonSx}
						>
							Guardar
						</Button>
					</Box>
				</Box>
			</BasicModal>
			</Box>
		</Box>
	);
};

Template103.thumbnail = "/images/templates/template-tk-checklist.png";

export default Template103;
